import React from 'react'
import CatalogOrderComponent from './CatalogOrderComponent'

import 'navigator.sendbeacon'

import packageJson from '../../package.json'
import { Tracking, TrackingProvider } from '../utils'

const { version: APP_VERSION } = packageJson

const CatalogOrderApp = ({
  gaId,
  gaDebug,
  mtId,
  mtUrl,
  ...props
}) => {
  const tracker = new Tracking({ enabled: true, gaId, mtId, mtUrl, debug: gaDebug })

  navigator.sendBeacon(
    'https://api.apps.austauschkompass.de/catalog_order_component/track',
    JSON.stringify({ version: APP_VERSION, url: document.location.href })
  )

  return (
    <TrackingProvider tracker={tracker}>
      <CatalogOrderComponent {...props} />
    </TrackingProvider>
  )
}

const htmlEnvToProps = ({ el, queryArgs }) => {
  const akConfig = JSON.parse(el.dataset.akConfig)

  const props = Object.assign({
    enabled: true,
    organisationId: queryArgs.organisation_id,
    apiUrl: `https://api.orders.austauschkompass.de`,
    crmApiUrl: `https://api.crm.austauschkompass.de`,
    exchangeCountryCode: queryArgs.target,
    referrer: queryArgs.redirect_uri,
    debug: false,
    upsell: false,
    upsellPrechecked: false,
    interestInSchoolPrograms: false,
    onFinish: (() => { window.location.href = queryArgs.redirect_uri })
  }, akConfig)

  return props
}

export {
  CatalogOrderComponent as default,
  CatalogOrderApp,
  htmlEnvToProps,
}
